<template>
  <ModalCard class="is-default-theme" :is-responsive="true">
    <template #body>
      <section class="has-text-centered m-t-20">
        <i class="cls cls-check-circle-1-filled is-size-2 has-text-success" />

        <p class="is-size-3 has-text-weight-semibold m-t-10">
          {{ $t('ai.thank-you-for-feedback') }}
        </p>

        <p class="is-size-5 m-t-10">
          {{ $t('ai.our-team-will') }}
        </p>

        <ButtonView class="button is-primary is-light m-t-50" @click="close">
          {{ $t('ai.close') }}
        </ButtonView>
      </section>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraFeedbackSubmittedModal',
  emits: ['on-close'],
  components: { ModalCard, ButtonView },
  methods: {
    close() {
      this.$emit('on-close');
    }
  }
};
</script>
